module.exports = __webpack_public_path__ + "img/Romantique.ba8667a.jpg";